import { useAppSelector } from '@app/redux/hooks';
import { Section } from '@ui-kit/Section';
import { ItemMenu } from './ItemMenu';
import { MyLink } from '@app/components/ui-kit/Link';
import { ErrorBoundaryComponent } from '@sharedUi/ErrorBoundary';

import styles from './HeaderBottom.module.scss';
import { ButtonRecordWidget } from '@features/callKolesoWidget';

export const HeaderBottom = (): JSX.Element => {
  const { menu, subMenuHeader } = useAppSelector(state => state.header.data.headerMenu);
  return (
    <ErrorBoundaryComponent>
      <div itemScope itemType="https://schema.org/SiteNavigationElement">
        <Section className={styles.Wrapper}>
          <div className={styles.MenuRow}>
            {menu?.map((item, index) => <ItemMenu key={item?.title} {...item} classSubMenu={index === 0 ? styles.LeftSubMenu : ''} />)}
          </div>
          <div className={styles.Separator}></div>
          <div className={styles.MenuRow}>
            <MyLink className={styles.LinkPage} href="/services/shinomontaj/" data-testid="menu-/services/shinomontaj/">
              Шиномонтаж
            </MyLink>
            <ItemMenu {...subMenuHeader?.find(item => item?.title === 'Автосервис')} />
            <MyLink className={styles.LinkPage} href="/services/sezonnoe-khranenie/" data-testid="headermenu-/services/sezonnoe-khranenie/">
              Хранение
            </MyLink>
            <ItemMenu {...subMenuHeader?.find(item => item?.title === 'Услуги')} />
            <ButtonRecordWidget className={styles.BtnRecord} />
          </div>
        </Section>
      </div>
    </ErrorBoundaryComponent>
  );
};
